module.exports = __webpack_public_path__ + "static/media/Billy.dd3064fa.jpg";